import React, { useRef, useState } from "react";
import { useFormik } from "formik"
import * as Yup from "yup"
import ReCAPTCHA from 'react-google-recaptcha';
import axios from "axios";
import { Spinner } from 'reactstrap';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

function SendComments({ id }) {
    const [codeResponse, setCodeResponse] = useState(0)
    const reCaptchaRef = useRef(null);

    const validationSchema = Yup.object().shape({
        subject: Yup.string().required("Debe ingresar el asunto")
            .min(5, "El asunto debe tener mínimo 5 caracteres")
            .max(50, "El asunto debe tener máximo 50 caracteres"),
        comment: Yup.string().required("Debe ingresar el comentario")
            .min(5, "El comentario debe tener mínimo 5 caracteres")
            .max(255, "El comentario debe tener máximo 255 caracteres"),
        recaptcha: Yup.string()
            .min(1, 'Demuestra que no eres un robot')
            .required('Demuestra que no eres un robot')
    })

    const formik = useFormik({
        initialValues: {
            subject: '',
            comment: '',
            recaptcha: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            setCodeResponse(0)
            const headers = {
                'Content-Type': 'application/vnd.api+json',
                'Accept': 'application/vnd.api+json'
            };

            const auth = {
                username: process.env.REACT_APP_JSON_API_USER,
                password: process.env.REACT_APP_JSON_API_PASS
            }

            const data = {
                "data": {
                    "type": "comment--comment",
                    "attributes": {
                        "subject": values.subject,
                        "field_name": "field_comentarios_dataset",
                        "entity_type": "node",
                        "status": false,
                        "comment_body": {
                            "value": values.comment,
                            "format": "plain_text"
                        }
                    },
                    "relationships": {
                        "entity_id": {
                            "data": {
                                "type": "node--data",
                                "id": id
                            }
                        }
                    }
                }
            }

            const response = await axios.post(process.env.REACT_APP_JSON_API_POST_COMENT, data, {
                headers: headers,
                auth: auth
            })
            if (response.status == 201) {
                NotificationManager.success('Proceso exitoso', 'Se ha enviado tu comentario', 10000);
                formik.resetForm({});
            } else {
                NotificationManager.error('Error', 'Ha ocurrido un error en el envío, por favor intente de nuevo', 10000);
            }
            reCaptchaRef.current.reset();
        }
    })

    return (
        <>
            <div className="mt-5 mb-5 position-relative">
                <div className={`loader ${formik.isSubmitting ? ' d-flex justify-content-center align-items-center' : 'd-none'}`}>
                    <Spinner color="primary" />
                </div>
                <div className="text-center">
                    <h3><b> Aviso importante para el Usuario</b></h3>
                    <p>  El espacio destinado a <b>“Comentarios del Usiuario” es exclusivamente</b>
                        Para recibir tus opiniones o sugerencias sobre la funcionalidad del portal MEDATA.</p>
                    <p>
                        Si deseas presentar una Petición, <b>Queja, Reclamo o Sugerencias (PQRS)</b>, te
                        Invitamos a utilizar el canal oficial disponible en el siguiente vinculo:
                        Presentar uan PQRS:
                        <a href="https//mercurio.medellin.gov.co/mercurio/inicialPqr.jsp" target="_blank">
                            https//mercurio.medellin.gov.co/mercurio/inicialPqr.jsp
                        </a>
                    </p>
                    <p><b>Recuerda:</b> este canal no debe ser utilizado para siolicitudes relacionadas con PQRS,
                        Se gestionan únicamente a través del enlace mencionado.</p>
                    <br />
                    <p>
                        Gracias por ayudarno a mejorar nuestros servicios.
                        <br />
                        <b>Distrito Especial de ciencia, Tecnología e Innovación de Medellín</b>
                        <br />
                        Comprometidos con la seguridad y calidad de la información.
                    </p>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="">Asunto:</label>
                        <input
                            type="text"
                            className="form-control"
                            name="subject"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.subject}
                        />
                        {formik.touched.subject && formik.errors.subject ?
                            <div className="mt-3 error">{formik.errors.subject}</div> : null}
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Mensaje:</label>
                        <textarea
                            className="form-control"
                            rows={3}
                            name="comment"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.comment} />
                        {formik.touched.comment && formik.errors.comment ?
                            <div className="mt-3 error">{formik.errors.comment}</div> : null}
                    </div>
                    <div className="form-group">

                        <ReCAPTCHA
                            style={{ display: 'inline-block' }}
                            ref={reCaptchaRef}
                            sitekey={process.env.REACT_APP_SITE_KEY}
                            name="recaptcha"
                            id="recaptcha"
                            value={formik.values.recaptcha}
                            onBlur={formik.handleBlur}
                            onChange={async () => {
                                const token = await reCaptchaRef.current.getValue();
                                formik.setFieldValue('recaptcha', token);
                            }}
                        />
                        {formik.touched.recaptcha && formik.errors.recaptcha ? (
                            <div className="mt-3 error">{formik.errors.recaptcha}</div>
                        ) : null}
                    </div>

                    <button type="submit" class="button button-secondary" disabled={formik.isSubmitting}>Enviar</button>
                </form>
            </div>
            <NotificationContainer />
        </>
    )
}

export default SendComments